import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components/native';
import { View, Pressable } from 'react-native';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useHover } from 'react-native-web-hooks';
import OutsidePressHandler from 'react-native-outside-press';
import Icon from '../icon';
import Colors from '../colors';
import Text from '../text';
import useDidMountEffect from '../hooks/use-did-mount-effect';
const StyledTextInput = styled.TextInput`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  height: 50px;
  background: ${Colors.lightGray100};
  border: 1px solid;
  border-color: ${props => props.error ? Colors.error400 : Colors.lightGray500};
  box-sizing: border-box;
  border-radius: 4px;
  align-self: stretch;
  margin: 2px 0px;
  font-family: Larsseit;
  font-size: 16px;
  font-style: normal;
  outline-color: ${Colors.advanceBlue400};
  color: ${Colors.gray600};
  placeholder-text-color: ${props => props.disabled ? Colors.lightGray500 : Colors.gray200};
`;
const StyledOptionContainer = styled.View`
  background: ${props => props.hovered ? Colors.lightGray200 : 'white'};
  padding: 6px 12px 8px;
`;
const StyledDropDownContainer = styled.ScrollView`
  background-color: white;
  box-shadow: 0px 4px 8px rgba(153, 153, 153, 0.25);
  padding-vertical: 8px;
  max-height: 216px;
`;
const StyledArrow = styled.View`
  position: absolute;
  right: 12px;
  bottom: 15px;
`;
export default function DropDown(props) {
  var _props$items$find;

  const defaultValue = (_props$items$find = props.items.find(item => item.value === props.defaultValue)) !== null && _props$items$find !== void 0 ? _props$items$find : {};
  const ref = useRef(null);
  const [focused, setFocused] = useState(false);
  const [selected, setSelected] = useState(defaultValue);
  useEffect(() => {
    var _props$items$find2;

    if (!props.value) return;
    const value = (_props$items$find2 = props.items.find(item => item.value === props.value)) !== null && _props$items$find2 !== void 0 ? _props$items$find2 : {};
    setSelected(value);
  }, [props.items, props.value]);
  useDidMountEffect(() => {
    if (!focused && props.onBlur) props.onBlur();
  }, [props.onBlur, focused]);
  return /*#__PURE__*/React.createElement(OutsidePressHandler, {
    onOutsidePress: () => setFocused(false)
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    ref: ref,
    focused: focused,
    error: props.error,
    disabled: props.disabled,
    color: props.disabled ? Colors.gray200 : props.error ? Colors.error400 : focused ? Colors.advanceBlue400 : Colors.gray300
  }, props.label), /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => setFocused(!focused)
  }, /*#__PURE__*/React.createElement(View, {
    pointerEvents: "none"
  }, /*#__PURE__*/React.createElement(StyledTextInput, {
    ref: ref,
    value: selected.label,
    placeholder: props.placeholder,
    error: props.error,
    disabled: props.disabled
  })), /*#__PURE__*/React.createElement(StyledArrow, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: focused ? 'keyboard-arrow-up' : 'keyboard-arrow-down',
    size: 24,
    color: Colors.gray400
  }))), !focused && !!props.helper && /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: props.disabled ? Colors.gray100 : props.error ? Colors.error400 : Colors.gray400
  }, props.helper), focused && /*#__PURE__*/React.createElement(StyledDropDownContainer, {
    keyboardShouldPersistTaps: "handled",
    nestedScrollEnabled: true
  }, props.items.filter(item => _.lowerCase(item.label)).map(item => /*#__PURE__*/React.createElement(Option, {
    key: item.value,
    item: item,
    onPress: () => {
      setSelected(item);
      setFocused(false);
      props.onChange(item);
    }
  }))));
}

function Option(props) {
  const ref = useRef();
  const hovered = useHover(ref);
  return /*#__PURE__*/React.createElement(Pressable, {
    key: props.item.value,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledOptionContainer, {
    ref: ref,
    hovered: hovered
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: hovered ? Colors.purple400 : Colors.gray600
  }, props.item.label)));
}

DropDown.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  helper: PropTypes.string
};
DropDown.defaultProps = {
  label: 'Select an item',
  placeholder: '',
  items: [],
  error: false,
  onChange: () => {},
  onBlur: () => {},
  defaultValue: '',
  value: undefined,
  disabled: false,
  helper: ''
};
Option.propTypes = {
  onPress: PropTypes.func,
  item: PropTypes.object
};
Option.defaultProps = {
  onPress: () => {},
  item: {}
};
//# sourceMappingURL=drop-down.js.map